import { CPFValidator } from "./genericValidator";

export const CNPJValidator = (value: string | undefined): boolean => {
  if (value === undefined) return false;

  const cnpj = value.replace(/\D/g, "");
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1*$/.test(cnpj)) return false;

  const calcDigit = (base: string, weights: number[]): number => {
    const sum = weights.reduce(
      (acc, weight, index) => acc + parseInt(base.charAt(index), 10) * weight,
      0,
    );
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const first = calcDigit(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (first !== parseInt(cnpj.charAt(12), 10)) return false;

  const second = calcDigit(cnpj, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  return second === parseInt(cnpj.charAt(13), 10);
};

export const documentValidator = (value: string | undefined): boolean => {
  if (value === undefined) return false;
  const digits = value.replace(/\D/g, "");
  if (digits.length === 11) return CPFValidator(digits);
  if (digits.length === 14) return CNPJValidator(digits);
  return false;
};
